export class GetAccountCount {
  static type = '[Accounts] Get Count';

  constructor(readonly customerId: number) {}
}

export class GetAllAccounts {
  static type = '[Accounts] Get All';

  constructor(readonly customerId: number) {}
}

export class RefreshAccounts {
  static type = '[Accounts] Refresh';

  constructor(
    readonly customerId: number,
    readonly adspertAccountIds?: number[],
  ) {}
}

export class CancelAccountMove {
  static type = '[Accounts] Cancel Move';

  constructor(
    readonly adspertAccountId: number,
    readonly customerId: number,
  ) {}
}

export class CancelAllAccountMove {
  static type = '[Accounts] Cancel All Move';

  constructor(readonly customerId: number) {}
}
